var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToolbarWithProps } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import Loading from '../common/Loading';
import { VideoTile } from './video-tile';
import CenteredSign from '../common/CenteredSign';
import { eventType } from './event-list-page-ui';
export function EventDetailsPageUI(props) {
    var type = eventType(props.name);
    var title = type === 'insiderSeries'
        ? 'Applied AI Insiders Series'
        : type === 'conference'
            ? 'Applied AI Conference'
            : 'Event';
    var Layout = function (_a) {
        var children = _a.children;
        return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithProps, __assign({ cancel: { type: 'back', onClick: props.onBackClick }, action: props.onEditClick
                        ? { type: 'edit', onClick: props.onEditClick }
                        : undefined }, { children: title }), void 0), children] }, void 0));
    };
    if (props.loading) {
        return (_jsx(Layout, { children: _jsx(Loading, {}, void 0) }, void 0));
    }
    return (_jsx(Layout, { children: _jsx(Body, { children: _jsxs(Grid, { children: [_jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: props.name }, void 0),
                            _jsx(TileComment, { children: props.description }, void 0)] }), void 0),
                    props.videos.length === 0 ? (_jsx(Tile, __assign({ span: 12 }, { children: _jsx(CenteredSign, { children: "Videos will be available soon" }, void 0) }), void 0)) : (props.videos.map(function (video) { return _jsx(VideoTile, __assign({}, video), video.id); }))] }, void 0) }, void 0) }, void 0));
}
//# sourceMappingURL=event-details-page-ui.js.map